import {actions, ActionType} from './action';
import {IEpisodeSort, ITheme} from '../../common/type';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../common/util/redux';
import {
  IAddedCashItem,
  IAddedTicketItem,
  IAddedDaumCashItem,
  IUsedDaumCashItem,
  IMyNews,
  IThirdPartyTerm,
  IUsedCashItem,
  IUsedTicketItem,
  IWaitfreeContent,
} from '../type';

export interface IStateMore {
  inquiryIndex?: number;
  /*
   TODO
   selectedEpisodeSort는 하단탭 스프린트 이후 사용하지 않는다.
   추후 More.tsx / Setting.tsx 파일이 삭제되면 삭제하자.
   */
  selectedEpisodeSort: IEpisodeSort;
  selectedTheme: ITheme;
  thirdPartyTerms?: IThirdPartyTerm[];
  showSuccessCopuon: boolean;
  hasNewMore: boolean;
  myNewsList: IMyNews[];
  waitfreeList: IWaitfreeContent[];
  selectedList: number[];
  cash: {
    added: IAddedCashItem[];
    used: IUsedCashItem[];
  };
  ticket: {
    added: IAddedTicketItem[];
    used: IUsedTicketItem[];
  };
  daumCash: {
    added: IAddedDaumCashItem[];
    used: IUsedDaumCashItem[];
  };
}

const INITIAL_STATE: IStateMore = {
  inquiryIndex: undefined,
  selectedEpisodeSort: 'latest',
  selectedTheme: 'dark',
  thirdPartyTerms: undefined,
  showSuccessCopuon: false,
  hasNewMore: false,
  myNewsList: [],
  waitfreeList: [],
  selectedList: [],
  cash: {
    added: [],
    used: [],
  },
  ticket: {
    added: [],
    used: [],
  },
  daumCash: {
    added: [],
    used: [],
  },
};

export default createReducer<IStateMore, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.ConfirmMyNews]: (state, action) => {
      const myNews = state.myNewsList.find(
        myNews => myNews.id === action.payload.id
      );
      if (myNews) {
        myNews.isRead = true;
      }
    },
    [ActionType.AddMyNewsList]: (state, action) => {
      const {myNewsList, isFirst} = action.payload;
      if (isFirst) state.myNewsList = [];
      state.myNewsList.push(...myNewsList);
    },
    [ActionType.AddWaitfreeList]: (state, action) => {
      const {waitfreeList, isFirst} = action.payload;
      if (isFirst) state.waitfreeList = [];
      state.waitfreeList.push(...waitfreeList);
    },
    [ActionType.AddCashContents]: (state, action) => {
      const {isFirst, tab, contents} = action.payload;
      isFirst && (state.cash[tab] = []);
      // @ts-ignore: 액션 생성자에게 타입을 제대로 정의해서 괜찮다
      state.cash[tab].push(...contents);
    },
    [ActionType.AddTicketContents]: (state, action) => {
      const {contents, tab, isFirst} = action.payload;
      isFirst && (state.ticket[tab] = []);
      // @ts-ignore: 액션 생성자에게 타입을 제대로 정의해서 괜찮다
      state.ticket[tab].push(...contents);
    },
    [ActionType.AddDaumCashContents]: (state, action) => {
      const {isFirst, tab, contents} = action.payload;
      isFirst && (state.daumCash[tab] = []);
      // @ts-ignore: 액션 생성자에게 타입을 제대로 정의해서 괜찮다
      state.daumCash[tab].push(...contents);
    },
  }
);
